import React from "react";
import {Button, Modal} from "react-bootstrap";
import Reports from "./Reports";
import {useHandleClose} from "../commons/ModalHelpers";

class ReportModalErrorBoundaryInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error('report modal error boundary caught an error', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    }
}

const ReportModalErrorFallback = ({title, onClose, onBackToReports}) => {
    return <Modal size="md" show={true} onHide={onClose} animation={false}>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Wystąpił nieoczekiwany błąd. Zamknij okno i spróbuj ponownie.</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-primary" onClick={onClose}>Zamknij</Button>
            <Button variant="outline-secondary" onClick={onBackToReports}>Wróć do raportów</Button>
        </Modal.Footer>
    </Modal>;
}

const ReportModalErrorBoundary = ({children, title = 'Nie udało się otworzyć okna raportu'}) => {
    const handleClose = useHandleClose(Reports.url);
    const handleBackToReports = useHandleClose(Reports.url, true);

    return <ReportModalErrorBoundaryInner fallback={
        <ReportModalErrorFallback
            title={title}
            onClose={handleClose}
            onBackToReports={handleBackToReports}
        />
    }>
        {children}
    </ReportModalErrorBoundaryInner>;
}

export default ReportModalErrorBoundary;

